<div>
  @if (showFilters) {
    <wl-commodity-offer-filter
      class="d-block w-100 mb-5"
      [offers]="offers"
      [selectedContractType]="selectedContractType"
      [availableContractTypes]="availableContractTypes"
      (changeContractType)="changeContractType($event)"
    ></wl-commodity-offer-filter>
  }

  <div
    class="d-flex offer-list justify-content-center"
    [class.offer-list--vertical]="computedVariant === 'accordion'"
    [class.offer-list--has-floating-label]="listContainsHighlights"
    [class.mt-xl-6]="
      brand === 'ed' &&
      alignment === 'horizontal' &&
      listContainsHighlights &&
      !showFilters
    "
    wlAutomationId="commodity-offer-list-offers"
  >
    @if (
      isBrandSegmentType({
        brand: 'essent',
        segment: 'consument',
        type: 'open',
        currentBrand: brand,
        currentSegment: segment,
        currentType: type,
      })
    ) {
      @if (offers && offers.length > 0) {
        @for (offer of prioritizedOffers; track offer) {
          <essent-consumer-acquisition-commodity-offer
            [offer]="offer"
            [variant]="computedVariant"
            [content]="content"
            [active]="isActive(offer)"
            [showMemberGetMember]="showMemberGetMember"
            [ensureHorizontalAlignment]="listContainsHighlights"
            [hideCommodityProductBreakdownTable]="
              !!content?.hideCommodityProductBreakdownTable
            "
            [useAlternateCommodityTariffView]="
              !!content?.useAlternateCommodityTariffView
            "
            [centerAlignedTariffLink]="!!content?.centerAlignedTariffLink"
            [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
            [termijnbedragVariantA]="!!content?.termijnbedragVariantA"
            [termijnbedragVariantB]="!!content?.termijnbedragVariantB"
            (selectOffer)="selectOffer.emit(offer)"
            (openMoreInfo)="openMoreInfo.emit(offer)"
            (viewTariffs)="viewTariffs.emit(offer)"
          ></essent-consumer-acquisition-commodity-offer>
        }
      } @else {
        @for (_ of [1, 2, 3]; track _) {
          <essent-consumer-acquisition-commodity-offer
            [showLoadingState]="true"
            [variant]="computedVariant"
            [active]="false"
            [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
          ></essent-consumer-acquisition-commodity-offer>
        }
      }
    }

    @if (
      isBrandSegmentType({
        brand: 'ed',
        segment: 'consument',
        type: 'open',
        currentBrand: brand,
        currentSegment: segment,
        currentType: type,
      })
    ) {
      @if (offers && offers.length > 0) {
        @for (offer of prioritizedOffers; track offer) {
          <ed-consumer-acquisition-commodity-offer
            [offer]="offer"
            [variant]="computedVariant"
            [content]="content"
            [hideCommodityProductBreakdownTable]="
              !!content?.hideCommodityProductBreakdownTable
            "
            [useAlternateCommodityTariffView]="
              !!content?.useAlternateCommodityTariffView
            "
            [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
            [termijnbedragVariantA]="!!content?.termijnbedragVariantA"
            [termijnbedragVariantB]="!!content?.termijnbedragVariantB"
            [active]="isActive(offer)"
            [showMemberGetMember]="showMemberGetMember"
            [ensureHorizontalAlignment]="listContainsHighlights"
            [showTariffs]="showTariffsForAllOffers"
            (selectOffer)="selectOffer.emit(offer)"
            (openMoreInfo)="openMoreInfo.emit(offer)"
            (viewTariffModal)="viewTariffs.emit(offer)"
            (openTariffDropdown)="_showTariffsForAllOffers = true"
            (closeTariffDropdown)="_showTariffsForAllOffers = false"
          ></ed-consumer-acquisition-commodity-offer>
        }
      } @else {
        @for (_ of [1, 2, 3]; track _) {
          <ed-consumer-acquisition-commodity-offer
            [showLoadingState]="true"
            [variant]="computedVariant"
            [active]="false"
            [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
          ></ed-consumer-acquisition-commodity-offer>
        }
      }
    }

    @if (
      isBrandSegmentType({
        brand: 'essent',
        segment: 'zakelijk',
        type: 'open',
        currentBrand: brand,
        currentSegment: segment,
        currentType: type,
      })
    ) {
      @if (offers && offers.length > 0) {
        @for (offer of prioritizedOffers; track offer) {
          <essent-sme-acquisition-commodity-offer
            [offer]="offer"
            [variant]="computedVariant"
            [content]="content"
            [active]="isActive(offer)"
            [showMemberGetMember]="showMemberGetMember"
            [ensureHorizontalAlignment]="listContainsHighlights"
            [enableNewOfferCardTitles]="content?.enableNewOfferCardTitles"
            (selectOffer)="selectOffer.emit(offer)"
            (openMoreInfo)="openMoreInfo.emit(offer)"
            (viewTariffs)="viewTariffs.emit(offer)"
          ></essent-sme-acquisition-commodity-offer>
        }
      } @else {
        @for (_ of [1, 2, 3]; track _) {
          <essent-sme-acquisition-commodity-offer
            [showLoadingState]="true"
            [variant]="computedVariant"
            [active]="false"
            [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
          ></essent-sme-acquisition-commodity-offer>
        }
      }
    }

    @if (
      isBrandSegmentType({
        brand: 'essent',
        segment: 'consument',
        type: 'mijn',
        currentBrand: brand,
        currentSegment: segment,
        currentType: type,
      })
    ) {
      @if (offers && offers.length > 0) {
        @if (content?.useMinimalOfferCards) {
          @for (offer of prioritizedOffers; track offer) {
            <essent-consumer-retention-minimal-commodity-offer
              [offer]="offer"
              [variant]="computedVariant"
              [content]="content"
              [active]="isActive(offer)"
              [ensureHorizontalAlignment]="
                listContainsHighlights || listContainsIncentives
              "
              [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
              (selectOffer)="selectOffer.emit(offer)"
              (viewTariffs)="viewTariffs.emit(offer)"
              (openMoreInfo)="openMoreInfo.emit(offer)"
            >
            </essent-consumer-retention-minimal-commodity-offer>
          }
        } @else {
          @for (offer of prioritizedOffers; track offer) {
            <essent-consumer-retention-commodity-offer
              [offer]="offer"
              [variant]="computedVariant"
              [content]="content"
              [active]="isActive(offer)"
              [ensureHorizontalAlignment]="listContainsHighlights"
              [enableNewOfferCardTitles]="content?.enableNewOfferCardTitles"
              (selectOffer)="selectOffer.emit(offer)"
              (viewTariffs)="viewTariffs.emit(offer)"
            >
            </essent-consumer-retention-commodity-offer>
          }
        }
      } @else {
        @for (_ of [1, 2, 3]; track _) {
          <essent-consumer-retention-minimal-commodity-offer
            [showLoadingState]="true"
            [variant]="computedVariant"
            [active]="false"
            [enableNewOfferCardTitles]="!!content?.enableNewOfferCardTitles"
          ></essent-consumer-retention-minimal-commodity-offer>
        }
      }
    }

    @if (
      isBrandSegmentType({
        brand: 'ed',
        segment: 'consument',
        type: 'mijn',
        currentBrand: brand,
        currentSegment: segment,
        currentType: type,
      })
    ) {
      @if (offers && offers.length > 0) {
        @if (content?.useMinimalOfferCards) {
          @for (offer of prioritizedOffers; track offer) {
            <ed-consumer-retention-minimal-commodity-offer
              [offer]="offer"
              [variant]="computedVariant"
              [content]="content"
              [active]="isActive(offer)"
              [ensureHorizontalAlignment]="
                listContainsHighlights || listContainsIncentives
              "
              [enableNewOfferCardTitles]="content?.enableNewOfferCardTitles"
              (selectOffer)="selectOffer.emit(offer)"
              (viewTariffs)="viewTariffs.emit(offer)"
              (openMoreInfo)="openMoreInfo.emit(offer)"
            >
            </ed-consumer-retention-minimal-commodity-offer>
          }
        } @else {
          @for (offer of prioritizedOffers; track offer) {
            <ed-consumer-retention-commodity-offer
              [offer]="offer"
              [variant]="computedVariant"
              [content]="content"
              [active]="isActive(offer)"
              [showTariffs]="showTariffsForAllOffers"
              [enableNewOfferCardTitles]="content?.enableNewOfferCardTitles"
              (selectOffer)="selectOffer.emit(offer)"
              (openMoreInfo)="openMoreInfo.emit(offer)"
              (viewTariffModal)="viewTariffs.emit(offer)"
              (openTariffDropdown)="_showTariffsForAllOffers = true"
              (closeTariffDropdown)="_showTariffsForAllOffers = false"
            ></ed-consumer-retention-commodity-offer>
          }
        }
      } @else {
        @for (_ of [1, 2, 3]; track _) {
          <ed-consumer-retention-commodity-offer
            [showLoadingState]="true"
            [variant]="computedVariant"
            [active]="false"
            [enableNewOfferCardTitles]="content?.enableNewOfferCardTitles"
          ></ed-consumer-retention-commodity-offer>
        }
      }
    }

    @if (
      isBrandSegmentType({
        brand: 'essent',
        segment: 'zakelijk',
        type: 'mijn',
        currentBrand: brand,
        currentSegment: segment,
        currentType: type,
      })
    ) {
      @if (offers && offers.length > 0) {
        @for (offer of prioritizedOffers; track offer) {
          <essent-sme-retention-commodity-offer
            [offer]="offer"
            [variant]="computedVariant"
            [content]="content"
            [active]="isActive(offer)"
            [ensureHorizontalAlignment]="listContainsHighlights"
            [enableNewOfferCardTitles]="content?.enableNewOfferCardTitles"
            (selectOffer)="selectOffer.emit(offer)"
            (openMoreInfo)="openMoreInfo.emit(offer)"
            (viewTariffs)="viewTariffs.emit(offer)"
          ></essent-sme-retention-commodity-offer>
        }
      } @else {
        @for (_ of [1, 2, 3]; track _) {
          <essent-sme-retention-commodity-offer
            [showLoadingState]="true"
            [variant]="computedVariant"
            [active]="false"
            [enableNewOfferCardTitles]="content?.enableNewOfferCardTitles"
          ></essent-sme-retention-commodity-offer>
        }
      }
    }
  </div>
</div>
